import { RootState } from "../models";

export const selectCollectAnalytics = (state: RootState) => {
  const collectAnalytics = state.data.isLoaded ? state.data.collectAnalytics :false;
  return collectAnalytics;
};
